"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var FalconAccordion = /** @class */ (function (_super) {
    __extends(FalconAccordion, _super);
    function FalconAccordion(props) {
        var _this = _super.call(this, props) || this;
        _this.renderIfTop = function () {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { onClick: _this.toggle, onKeyDown: _this.toggle, tabIndex: 0, children: _this.state.isShown ? _this.props.toggleShown : _this.props.toggleHidden }), _this.state.isShown && (0, jsx_runtime_1.jsx)("div", { children: _this.props.children })] }));
        };
        _this.renderIfBottom = function () {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.state.isShown && (0, jsx_runtime_1.jsx)("div", { children: _this.props.children }), (0, jsx_runtime_1.jsx)("div", { onClick: _this.toggle, onKeyDown: _this.toggle, tabIndex: 0, children: _this.state.isShown ? _this.props.toggleShown : _this.props.toggleHidden })] }));
        };
        _this.toggle = function () {
            _this.setState({ isShown: !_this.state.isShown });
        };
        _this.state = {
            isShown: _this.props.isOpen || false
        };
        return _this;
    }
    FalconAccordion.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "falcon-accordion ".concat(this.props.className), children: this.props.togglePositionTop ? this.renderIfTop() : this.renderIfBottom() }));
    };
    return FalconAccordion;
}(React.Component));
exports.FalconAccordion = FalconAccordion;
//# sourceMappingURL=FalconAccordion.js.map